var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgEarth = function SvgEarth(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#323338",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M10 19a9 9 0 1 0 0-18 9 9 0 0 0 0 18"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#323338",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M7.831 18.737C6.613 16.95 5.8 13.707 5.8 10s.813-6.951 2.031-8.737M1 10h18M2.386 14.8h15.229M2.386 5.2h15.229M12.169 1.263C13.386 3.05 14.2 6.293 14.2 10s-.813 6.951-2.031 8.737"
  })));
};
export default SvgEarth;